/** The one running A, reachable from links and forms without importing the engine. */
export type MascotApi = {
  /** Take over an internal navigation (the cloth drag). False = let Next.js navigate normally. */
  navigate(href: string): boolean;
  /** The contact form composed a letter: A carries it up to the logo. */
  carryLetter(): void;
};

let current: MascotApi | null = null;

export function setMascot(m: MascotApi | null) {
  current = m;
}

export function getMascot(): MascotApi | null {
  return current;
}
